import { emailRegex, phoneRegex2, registerNumber } from './constants'

export const moneyFormatter = (val: number | string | undefined): string => {
  let price: number
  if (val === undefined) {
    return '0₮'
  }
  if (typeof val === 'string') {
    price = parseInt(val)
  } else {
    price = Math.ceil(val)
  }
  return Intl.NumberFormat('en-US').format(price) + '₮'
}

export const isNil = (val: any): boolean => {
  return val === null || val === undefined || val === ''
}

export const checkEmail = (email: string): boolean => {
  return emailRegex.test(email) && email.trim() !== ''
}
export const phoneNumber2 = (number: string): boolean => {
  return phoneRegex2.test(number) && number.trim() !== ''
}
export const encodeToBase64 = (inputString: string): string => {
  const buffer = Buffer.from(inputString, 'utf-8')
  const base64String = buffer.toString('base64')
  return base64String
}

export const decodeFromBase64 = (base64String: string): string => {
  const buffer = Buffer.from(base64String, 'base64')
  const decodedString = buffer.toString('utf-8')
  return decodedString
}

export const isCorpRegister = (val: string): boolean => {
  return registerNumber.test(val) || /^\d{7}$/.test(val)
}

export const isMobile = (): 'MOBILE' | 'WEB' => {
  return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || window.innerWidth <= 768
    ? 'MOBILE'
    : 'WEB'
}
